export const ConnectedLms = {
    Teams: 'teams',
    Canvas: 'canvas',
    Unknown: '',
};
export default ConnectedLms;
